/**
 * @generated SignedSource<<d430cbf4d89992573a6f3e8f218261c9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoReceiversSetStoreIdsMutation$variables = {
  id: string;
  storeIds?: ReadonlyArray<string> | null;
};
export type WorkspaceTodoReceiversSetStoreIdsMutation$data = {
  readonly todoWorkspace: {
    readonly updateReceiverStoreIds: {
      readonly id: string;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly todoCount: number;
      readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoEditMainEditedInfo_Todo">;
    };
  };
};
export type WorkspaceTodoReceiversSetStoreIdsMutation$rawResponse = {
  readonly todoWorkspace: {
    readonly updateReceiverStoreIds: {
      readonly id: string;
      readonly receiverStores: ReadonlyArray<{
        readonly id: string;
      }>;
      readonly todoCount: number;
      readonly updatedAtDate: {
        readonly __isDate: "UnzonedDate";
        readonly isoString: string;
      } | null;
      readonly updatedBy: {
        readonly id: string;
        readonly name: string;
      } | null;
    };
  };
};
export type WorkspaceTodoReceiversSetStoreIdsMutation = {
  rawResponse: WorkspaceTodoReceiversSetStoreIdsMutation$rawResponse;
  response: WorkspaceTodoReceiversSetStoreIdsMutation$data;
  variables: WorkspaceTodoReceiversSetStoreIdsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeIds"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "storeIds",
    "variableName": "storeIds"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "todoCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Store",
  "kind": "LinkedField",
  "name": "receiverStores",
  "plural": true,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceTodoReceiversSetStoreIdsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverStoreIds",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkspaceTodoEditMainEditedInfo_Todo"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceTodoReceiversSetStoreIdsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodoWorkspaceMutation",
        "kind": "LinkedField",
        "name": "todoWorkspace",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "TodoWorkspace",
            "kind": "LinkedField",
            "name": "updateReceiverStoreIds",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "updatedBy",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "UnzonedDate",
                "kind": "LinkedField",
                "name": "updatedAtDate",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isoString",
                        "storageKey": null
                      }
                    ],
                    "type": "Date",
                    "abstractKey": "__isDate"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8ee6db3b58f5e1696307331eef015c6e",
    "id": null,
    "metadata": {},
    "name": "WorkspaceTodoReceiversSetStoreIdsMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceTodoReceiversSetStoreIdsMutation(\n  $id: ID!\n  $storeIds: [ID!]\n) {\n  todoWorkspace(id: $id) {\n    updateReceiverStoreIds(storeIds: $storeIds) {\n      id\n      todoCount\n      receiverStores {\n        id\n      }\n      ...WorkspaceTodoEditMainEditedInfo_Todo\n    }\n  }\n}\n\nfragment FormattedDate on Date {\n  __isDate: __typename\n  ...useFormattedDate\n}\n\nfragment WorkspaceTodoEditMainEditedInfo_Todo on TodoWorkspace {\n  updatedBy {\n    id\n    name\n  }\n  updatedAtDate {\n    ...FormattedDate\n  }\n}\n\nfragment useFormattedDate on Date {\n  __isDate: __typename\n  isoString\n}\n"
  }
};
})();

(node as any).hash = "de663e080738ec04d86f41cdb976450b";

export default node;
